import { render, staticRenderFns } from "./effectDetailClue.vue?vue&type=template&id=392ef0f6&scoped=true"
import script from "./effectDetailClue.vue?vue&type=script&lang=js"
export * from "./effectDetailClue.vue?vue&type=script&lang=js"
import style0 from "./effectDetailClue.vue?vue&type=style&index=0&id=392ef0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392ef0f6",
  null
  
)

export default component.exports